
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 6C3.355 6 2 7.355 2 9v14c0 1.645 1.355 3 3 3h22c1.645 0 3-1.355 3-3V9c0-1.645-1.355-3-3-3zm0 2h22c.566 0 1 .434 1 1v14c0 .566-.434 1-1 1H5c-.566 0-1-.434-1-1V9c0-.566.434-1 1-1zm3.156 3C6.93 11 6 11.777 6 13.125V21h3.938c.96 0 2.062-.895 2.062-2.063V11zm7 0C13.934 11 13 11.781 13 13.125v7.813h3.938c.957 0 2.062-.899 2.062-2.063V11zm7 0C20.934 11 20 11.781 20 13.125v7.813h3.906c.953 0 2.094-.899 2.094-2.063V11zm-6.781 3h2.875v.625c-.688-.16-1.36-.25-1.688-.25-.718 0-1.28.617-1.28 1.375s.562 1.344 1.28 1.344c.329 0 1-.059 1.688-.219v.594h-2.875c-.895 0-1.656-.774-1.656-1.719 0-.945.761-1.75 1.656-1.75zm5.469 0h3.687c.45 0 .813.395.813.844 0 .445-.301.875-.75.875.508 0 .906.398.906.844 0 .449-.398.875-.906.875h-3.75zm-11.375.031h1.719v1.938c0 1.078-1.387 1.656-2.407 1.656-1.11 0-2.101-.66-2.312-1.5h.75c.09.512.586.875 1.156.875.629 0 1.094-.46 1.094-1.031zm12.781.313V15.5h1.188a.581.581 0 00.562-.563c0-.296-.266-.593-.563-.593zm0 1.594v1.156h1.219c.3 0 .562-.266.562-.563 0-.3-.261-.593-.562-.593z"}})])
          )
        }
      }
    